<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('zclstj')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('groupName')">
                                    <el-select size="small" v-model="searchform.groupId" style="width:180px;" :placeholder="$t('qxzrole')"  >
                                        <el-option :label="$t('buxian')" :value="0"></el-option>
                                        <el-option v-for="(item,index) in grouplist" :label="item.groupName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                    <el-button size="small" type="primary" @click="exportDate">{{$t('tel84')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" :span-method="objectSpanMethod" border :summary-method="getSummaries" show-summary
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="dayTime" :rowspan="2" :label="$t('value2')"></el-table-column>
                        <el-table-column prop="groupName" :label="$t('groupName')"></el-table-column>
                        <el-table-column prop="callNum" :label="$t('zczds')"></el-table-column>
                        <el-table-column prop="recall" :label="$t('jrchds')"></el-table-column>
                        <el-table-column prop="recallRate" :label="$t('jrchl')"></el-table-column>
                        <el-table-column :formatter="formatInteres" prop="callMoney" :label="$t('zcje')"></el-table-column>
                        <el-table-column :formatter="formatInteres" prop="recallMoney" :label="$t('chje')"></el-table-column>
                        <el-table-column prop="recallMoneyRate" :label="$t('chjel')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="120" fixed="right">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="$t('cd1')" placement="top">
                                     <el-button size="small" @click="queryDetail(scope.row)" type="primary" icon="el-icon-guide" circle plain></el-button>
                                </el-tooltip>
                                <el-tooltip v-if="(scope.row.groupName == 'S1' || scope.row.groupName == 'S2')" class="item" effect="dark" content="查看每天详情" placement="top">
                                     <el-button size="small" @click="queryDayDetail(scope.row)" type="primary" icon="el-icon-guide" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    groupName:null,
                    dayTime: null,
                    callNum: null,
                    recall: null,
                    recallRate: null,
                    callMoney: null,
                    recallMoney: null,
                    recallMoneyRate:null
                },
                searchform: {
                    blurry: "",
                },
                loading: false,
                list: [],
                value1:[],
                grouplist:[],
                count: 0,
                user:null,
                status: null,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getgrouplist()
        },
        methods: {
            formatInteres(row, column, value) {
                // 将值转换为数字，若转换失败则返回原值
                const number = Number(value);
                return isNaN(number) ? value : number.toLocaleString('en-US');
            },
            getSummaries({ columns, data}) {
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = this.$t('total') || '总计';
                        return;
                    }

                    // 定义需要求和的字段
                    const propsToSum = ['callNum', 'recall', 'callMoney', 'recallMoney'];
                    if (propsToSum.includes(column.property)) {
                        const total = data.reduce((prev, curr) => {
                            const value = Number(curr[column.property]);
                            return prev + (isNaN(value) ? 0 : value);
                        }, 0);
                        
                        // 金额类格式化
                        if (column.property.includes('Money')) {
                            sums[index] = total.toLocaleString('en-US');
                        } else {
                            sums[index] = total;
                        }
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
            queryDetail(row) {
                //this.$router.push({path:"/calldetail",query:{groupId:row.groupId,time:row.dayTime}})

                const { href } = this.$router.resolve({
                    path: "/calldetail",
                    query: { groupId: row.groupId, time: row.dayTime }
                })
                window.open(href, "_blank") // 新开一个标签页
            },
            queryDayDetail(row) {
                //this.$router.push({path:"/queryDayDetail",query:{groupId:row.groupId,time:row.dayTime}})

                const { href } = this.$router.resolve({
                    path: "/queryDayDetail",
                    query: { groupId: row.groupId, time: row.dayTime }
                })
                window.open(href, "_blank") // 新开一个标签页
            },
            getList() {
                this.loading = true
                _api.get(apiurl.callOldTotal, {
                    groupId: this.searchform.groupId,
                    nation:localStorage.getItem("nation"),
                    createTime: this.value1,
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.count = res.data.count
                })
            },
            exportDate() {
                _api.download(apiurl.exportCallOldTotal, {
                    groupId: this.searchform.groupId,
                    nation:localStorage.getItem("nation"),
                    createTime: this.value1,
                }).then(res => {
                    let a = document.createElement('a');
                    let blob = new Blob([res], {type: "application/vnd.ms-excel"});
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '再催历史统计数据.xls');
                    a.click();
                })
            },
            getgrouplist(){
                _api.get(apiurl.groupAll, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.grouplist = res.data
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },

            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (columnIndex === 0) {
                    if (rowIndex % this.count === 0) {
                        return {
                            rowspan: this.count,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>